<template>
  <div>
    <form class="needs-validation" @submit.prevent="checkForm()">
      <base-input label="Password" prop="password">
        <el-input
          type="password"
          v-model="changePassword.password"
          autocomplete="off"
          show-password
        ></el-input>
      </base-input>
      <base-input label="Confirm Password" prop="confirmPassword">
        <el-input
          type="password"
          v-model="changePassword.confirmPassword"
          autocomplete="off"
          show-password
        ></el-input>
      </base-input>
      <base-button md type="primary" native-type="submit">Submit</base-button>
    </form>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { Form, FormItem } from "element-ui";
import Validator from "@/plugins/customValidator";

export default {
  data: () => {
    return {
      formErrors: [],
      changePassword: {
        password: "",
        confirmPassword: ""
      }
    };
  },

  computed: {
    ...mapState("vendor", ["vendor"])
  },

  methods: {
    ...mapActions({
      changeVendorPassword: "vendor/changeVendorPassword"
    }),

    onSubmit() {
      this.vendor.password = this.changePassword.password;

      this.changeVendorPassword(this.vendor).then(response => {
        this.$notify({
          message: response.message,
          type: "success",
          title: "success"
        });
        this.resetForm();
      });
      this.$emit("close");
    },
    resetForm() {
      this.changePassword = {
        password: "",
        confirmPassword: ""
      };
    },
    checkForm(e) {
      this.formErrors = [];
      const vendorErrors = Validator.validateChangePassword(
        this.changePassword
      );
      this.formErrors = [...vendorErrors];
      if (!this.formErrors.length) {
        this.onSubmit();
      } else {
        this.formErrors.forEach(i => {
          this.$notify({
            message: i.msg,
            type: "danger",
            title: "Validation Error"
          });
        });
      }
    }
  },
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem
  }
};
</script>
